module.exports = __webpack_public_path__ + "img/kissstory.2caa23b1.png";